export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/oder_delivered.d57f5a55.svg","height":29,"width":17,"blurWidth":0,"blurHeight":0};